const yearOptions = {
    year: 'numeric',
};
/**
 * Return the string used to format the year for the given date. E.g ‘2023年’
 *  @param date - a given date
 *  @returns {string} - the string of the given date
 * */
export const getYear = (locale, date) => {
    return new Intl.DateTimeFormat(locale, yearOptions).format(date);
};
//# sourceMappingURL=getYear.js.map